import React from 'reactn';

import Page from 'components/Page';
import SimpleGrid from 'components/SimpleGrid';

import RaidsImage from 'resources/images/raids.png';
import BotImage from 'resources/images/osbot.png';
import TreeImage from 'resources/images/forest.png';
import BandosImage from 'resources/images/bandos.png';
import { ImageCard } from 'components';

const cards = [
	{
		title: 'Old School Bot',
		image: BotImage,
		desc: `Old School Bot is a discord bot based around Old School RuneScape. It has fun and useful
			commands, such as showing your account stats, and simulating loot.`,
		link: '/oldschoolbot'
	},
	{
		title: 'Loot Simulator',
		image: BandosImage,
		desc: 'The loot simulator lets you simulate loot and drops from monsters in OSRS. Simply pick a monster and kill it hundreds of times instantly.',
		link: '/monsters'
	},
	{
		title: 'Clue Simulator',
		image: TreeImage,
		desc: 'The Clue Simulator lets you simulate opening clue caskets, to see what loot and items you would get from all levels of clue scrolls.',
		link: '/clues'
	},
	{
		title: 'Raids Simulator',
		image: RaidsImage,
		desc: 'The Raids/Chambers of Xeric simulator lets you simulate raids and see what loot your team would get, shown in a realistic image.',
		link: '/raids'
	}
];

const Home: React.FC = () => (
	<Page>
		<SimpleGrid gridProps={{ spacing: 3 }} gridItemProps={{ xs: 'auto', sm: 6, md: 4 }}>
			{cards.map((card) => (
				<ImageCard {...card} />
			))}
		</SimpleGrid>
	</Page>
);

export default Home;
